import { PaymentsConfig } from '../types/ConfigTypes';
export const getPaymentsConfig = (): PaymentsConfig | undefined => {
  const globalConfig = window.ConfigUtility;

  if (!globalConfig) {
    console.warn('Unable to load payment config.');
    return;
  }

  return {
    agGridLicenseKey: globalConfig.agGridLicenseKey,
    apiBaseUri: globalConfig.apiBaseUri,
    cognito: {
      isEnabled: globalConfig.cognito.isEnabled,
      isMocked: false,
      userPoolId: globalConfig.cognito.userPoolId,
      userPoolWebClientId: globalConfig.cognito.paymentsUserPoolWebClientId,
      region: globalConfig.cognito.region,
    },
    consoleURL: globalConfig.consoleURL,
    cookies: {
      expires: '',
      path: globalConfig.cookies.path,
      domain: globalConfig.cookies.domain,
      secure: true,
    },
    env: globalConfig.env,
    fullstoryOrgId: globalConfig.fullstoryOrgId,
    launchDarklyClientId: globalConfig.paymentsLaunchDarklyClientId,
    launchDarklyProxyURL: globalConfig.launchDarklyProxyURL,
    loginURL: globalConfig.loginURL,
    logoutURL: globalConfig.logoutURL,
    mapBoxAccessToken: globalConfig.mapBoxAccessToken,
    monitoring: {
      applicationId: globalConfig.monitoring?.applicationId,
      clientToken: globalConfig.monitoring?.clientToken,
    },
    pendoApiKey: globalConfig.paymentsPendoApiKey,
    runMode: globalConfig.paymentsRunMode,
    snowplowURL: globalConfig.snowplowURL,
    standalone: globalConfig.paymentsStandalone,
    tokenLife: 15,
    useDevTools: globalConfig.useDevTools,
    bapi: {
      uri: globalConfig.bapi.uri,
    },
    papi: {
      uri: globalConfig.constructionPapi.uri,
    },
    paymentsPapi: {
      uri: globalConfig.paymentsPapi.uri,
    },
  };
};
